import { BaseEntity } from '../../models';
import { LeadSearch } from '../crm/lead';
import { Cliente } from '../pessoa/cliente';
import { Usuario } from '../usuario';
import { AtividadeChecklistItem } from './checklist-item';
import { MotivoPerdaVenda } from '../motivo-perda-venda';
import { AtividadeRef } from './ref';
import { AtividadeRetornoInsert } from './retorno';

export class Atividade implements BaseEntity {
    readonly id: number;
    idEmpresa: number;
    sequencia: number;
    lancamento: number;
    origem: number;
    referencia: number;
    setor: number;
    tipo: number;

    // Contato
    iniciativaContato: number;
    tipoContato: number;
    formaContato: number;
    idMotivoContato: number;
    motivoContato: MotivoPerdaVenda;

    idUsuarioOrigem: number;
    usuarioOrigem: Usuario;
    idUsuarioDestino: number;
    usuarioDestino: Usuario;
    titulo: string;
    idCliente: number;
    cliente: Cliente;
    idLead: number;
    lead: LeadSearch;
    sinalizado: boolean;
    importante: boolean;
    comentario: string;
    dataEmissao: Date;
    diaInicio: Date;
    horaInicio: Date;
    quantidadeMinutosExecucao: number;
    diaPrazo: Date;
    horaPrazo: Date;
    conclusaoBloqueada: boolean; // Se a opcão de concluir a atividade está bloqueada e a atividade não pode ser concluída
    concluida: boolean;
    dataConclusao: Date;
    idUsuarioConclusao: number;
    usuarioConclusao: Usuario;
    idFunilVendaOld: number;
    idTituloReceber: number;
    idNegocio: number;
    checklistItens: AtividadeChecklistItem[];
    quantidadeChecklistItens: number;
    quantidadeChecklistItensConcluidos: number;
    percQuantidadeChecklistItensConcluidos: number;

    // Retorno
    retornar: boolean;
    diaRetorno: Date;
    horaRetorno: Date;
    idAtividadeRetorno: number;
    atividadeRetorno: AtividadeRef;
    atividadeRetornoInsert: AtividadeRetornoInsert;

    // Atributos Auxiliares
    atrasada: boolean;

    constructor() {
        this.checklistItens = [];
        this.quantidadeChecklistItens = 0;
        this.quantidadeChecklistItensConcluidos = 0;
        this.percQuantidadeChecklistItensConcluidos = 0;

        // Retorno
        this.retornar = false;
    }
}

/** Realiza o map da entidade Atividade para seu type Ref */
export function mapToRef(entity: Atividade): AtividadeRef {
    if (!entity) {
        return null;
    }

    const entityRef: AtividadeRef = {
        id: entity.id,
        idEmpresa: entity.idEmpresa,
        sequencia: entity.sequencia,
        lancamento: entity.lancamento,
        origem: entity.origem,
        referencia: entity.referencia,
        setor: entity.setor,
        tipo: entity.tipo,
        titulo: entity.titulo,
        dataEmissao: entity.dataEmissao,
        diaPrazo: entity.diaPrazo,
        horaPrazo: entity.horaPrazo,
        comentario: entity.comentario,

        // Usuário origem
        idUsuarioOrigem: entity.idUsuarioOrigem,
        nomeUsuarioOrigem: entity.usuarioOrigem ? entity.usuarioOrigem.nome : '',
        avatarURLUsuarioOrigem: entity.usuarioOrigem ? entity.usuarioOrigem.avatarUrl : '',

        // Usuário destino
        idUsuarioDestino: entity.idUsuarioDestino,
        nomeUsuarioDestino: entity.usuarioDestino ? entity.usuarioDestino.nome : '',
        avatarURLUsuarioDestino: entity.usuarioDestino ? entity.usuarioDestino.avatarUrl : '',

        // Conclusão
        conclusaoBloqueada: entity.conclusaoBloqueada,
        concluida: entity.concluida,
        dataConclusao: entity.dataConclusao,
        idUsuarioConclusao: entity.idUsuarioConclusao,
        nomeUsuarioConclusao: entity.usuarioConclusao ? entity.usuarioConclusao.nome : '',
        avatarURLUsuarioConclusao: entity.usuarioConclusao ? entity.usuarioConclusao.avatarUrl : '',

        atrasada: entity.atrasada
    }

    return entityRef;
}
